
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/obchodni-podminky",
      function () {
        return require("private-next-pages/obchodni-podminky.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/obchodni-podminky"])
      });
    }
  